/**
 * The one address that opens 执行过程 for one face, written and read here.
 *
 * A card head's 「查看执行过程」 is a link, not a handler: a person may middle
 * click it, bookmark it, or come back to it tomorrow, and every one of those
 * has to land on the same narrowed page. So the narrowing lives in the hash.
 *
 * Two fields and no more:
 *
 * - `turn` — the turn the work ran in. Every row of that turn carries
 *   `row.turn_id`, so this narrows the stream to exactly what the Agent did;
 *   the server's own filters (`/api/timeline`) have no turn axis and the
 *   narrowing is therefore done over the rows the page already holds.
 * - `about` — what to call the face on the narrowed page. The panel's declared
 *   title, so the heading can be a sentence instead of an id.
 *
 * Both halves are optional in the sense that a bare `#/timeline` is still the
 * whole stream; written here rather than in either page so the one that mints
 * the link and the one that reads it cannot drift into two contracts.
 */

export interface SurfaceTrace {
  /** The turn whose rows to show. */
  turn: string;
  /** The face's declared title, for the heading. */
  about: string;
}

/** Where 「查看执行过程」 goes. */
export function traceHref(trace: SurfaceTrace): string {
  const params = new URLSearchParams({ turn: trace.turn, ...(trace.about ? { about: trace.about } : {}) });
  return `#/timeline?${params}`;
}

/** What a `#/timeline` hash asks to be narrowed to, or `null` for the lot. */
export function traceFromHash(hash: string): SurfaceTrace | null {
  const [path, query] = hash.replace(/^#\/?/, "").split("?", 2);
  if (path !== "timeline" || !query) return null;
  const params = new URLSearchParams(query);
  const turn = params.get("turn");
  return turn ? { turn, about: params.get("about") || "" } : null;
}
